import { jsxs as m, jsx as e, Fragment as c } from "react/jsx-runtime";
import "react";
import { slugify as h } from "../../utils/helpers.js";
import { AnchorTag as o } from "../AnchorTag/AnchorTag.js";
import '../../assets/NavList.css';const t = {
  "nav-list": "_nav-list_37is6_1",
  "nav-list__item": "_nav-list__item_37is6_7"
}, _ = ({ links: r = [], classname: s = "", toggleHandler: l = null }) => /* @__PURE__ */ e(c, { children: /* @__PURE__ */ e("ul", { className: [`${s}__nav-list`, t["nav-list"]].join(" "), children: r.map((a) => /* @__PURE__ */ e("li", { className: [`${s}__nav-item`, t["nav-list__item"]].join(" "), children: /* @__PURE__ */ e(
  o,
  {
    label: a.label,
    href: a.href,
    type: a.type,
    classname: `${s}__nav-link ${a != null && a.classname ? `${a.classname}` : ""}`,
    image: a != null && a.image ? a.image : null,
    clickHandler: l
  }
) }, `${s}-${Math.round(Math.random() * 1e7)}`)) }) });
function $({ title: r = "", links: s = [], classname: l = "", useNavWrapper: a = !1, toggleHandler: i = null }) {
  const n = h(r);
  if (a) return /* @__PURE__ */ m("nav", { "aria-labelledby": r !== "" ? n : null, className: l, children: [
    r !== "" && /* @__PURE__ */ e("h2", { id: r !== "" ? n : null, className: "h4", children: r }),
    /* @__PURE__ */ e(_, { links: s, classname: l, toggleHandler: i })
  ] });
  if (!a) return /* @__PURE__ */ m("div", { className: l, children: [
    r !== "" && /* @__PURE__ */ e("h2", { id: r !== "" ? n : null, className: "h4", children: r }),
    /* @__PURE__ */ e(_, { links: s, classname: l, toggleHandler: i })
  ] });
}
export {
  $ as NavList,
  $ as default
};
